export enum PageVisibilityState {
	hidden = 'hidden',
	prerender = 'prerender',
	unloaded = 'unloaded',
	visible = 'visible',
}
